import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-select';

	$.fn.select2.amd.require([
		'select2/utils',
		'select2/dropdown',
		'select2/dropdown/attachContainer',
		'select2/dropdown/search',
		'select2/dropdown/closeOnSelect'
	] , function (Utils, DropdownAdapter, AttachContainer, DropdownSearch, closeOnSelect ) {

		$(base, context).each(function(){
			var component = $(this);
			var select = component.find('select');
			var dataSelect = component.data('select');

			select.select2({
				width: "100%",
				dropdownParent: component,
				dropdownAdapter: Utils.Decorate(Utils.Decorate(DropdownAdapter, AttachContainer), closeOnSelect),
				closeOnSelect: true,
			});
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/b-select.js
// module id = 48
// module chunks = 0